export const handleBodyScrollOnModalShown = (modalShown: boolean) => {
  if (modalShown) {
    document.body.classList.add('modal-opened');
  } else {
    document.body.classList.remove('modal-opened');
  }
};
